<template>
  <div>
    <new-allMaintain showpages="allMaintain"></new-allMaintain>
  </div>
</template>

<script>
import backgroundDetail from '../../../components/backgroundDetail.vue' 
/**
 *@ClassName:projectWideRepoInfoBD
 *@Description:全项目报事信息-后台详情
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-21
 */
export default {
  components: {
    'new-allMaintain': backgroundDetail 
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
  
},
}
</script>
<style lang='scss'>
 
</style>